import { Battle, CharDied, Effect, EffectDuration, Event, Interrupt, Stats } from 'game/core'
import { Memoize } from 'game/util/memoize'

export class UnitedEffect extends Effect<{
    stacks: number
    increase: number
}>{
    static KEY = 'UnitedEffect' as const

    @Memoize()
    get duration(): EffectDuration {
        return {
            type: 'unlimited'
        }
    }

    @Memoize()
    get stacks(): number {
        return this.state.stacks
    }

    @Memoize()
    get increase(): number {
        return this.state.increase
    }

    // ----- Interrupts ----- //
    reactToEvent(event: Event): Interrupt {
        if (!(event instanceof CharDied)) return false
        if (event.side !== this.originSide) return false
        return this.finalize()
    }

    // ----- Appliers ----- //
    getTargetStats(currentStats: Stats): Stats {
        return {
            ...currentStats,
            strength: Math.max(0, currentStats.strength + this.increase)
        }
    }

    addStack(increase: number): Battle {
        return this.update({
            stacks: this.stacks + 1,
            increase: this.increase + increase
        })
    }
}
